/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_SizeInputs */

const en_reference_dataset_size = /** @type {(inputs: Reference_Dataset_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sizes`)
};

/**
* | output |
* | --- |
* | "Sizes" |
*
* @param {Reference_Dataset_SizeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_size = /** @type {((inputs?: Reference_Dataset_SizeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_SizeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_size(inputs)
});